import AutosizeTextarea from 'react-textarea-autosize'
import styled from 'styled-components'

import type { StyledCssProps } from '@subaio/components'

import { inputStyles } from '../Shared'

export const Textarea = styled(AutosizeTextarea)<StyledCssProps<typeof inputStyles>>`
	${inputStyles}
	min-height: unset;
	resize: none;
`
